var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnergy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108.869,
    height: 64.451,
    viewBox: "0 0 108.869 64.451",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#c8d1ec;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.043 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M37.74,24.282A1.984,1.984,0,0,0,35.9,23.043H27.348L34.425,2.635A1.985,1.985,0,0,0,31.151.577L.586,30.952a1.985,1.985,0,0,0,1.4,3.392h8.467l-7.7,20.369a1.984,1.984,0,0,0,3.238,2.126l31.3-30.387A1.984,1.984,0,0,0,37.74,24.282Z",
    transform: "translate(0 8.522) rotate(-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.412 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M37.74,24.282A1.984,1.984,0,0,0,35.9,23.043H27.348L34.425,2.635A1.985,1.985,0,0,0,31.151.577L.586,30.952a1.985,1.985,0,0,0,1.4,3.392h8.467l-7.7,20.369a1.984,1.984,0,0,0,3.238,2.126l31.3-30.387A1.984,1.984,0,0,0,37.74,24.282Z",
    transform: "translate(0 8.522) rotate(-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M37.74,24.282A1.984,1.984,0,0,0,35.9,23.043H27.348L34.425,2.635A1.985,1.985,0,0,0,31.151.577L.586,30.952a1.985,1.985,0,0,0,1.4,3.392h8.467l-7.7,20.369a1.984,1.984,0,0,0,3.238,2.126l31.3-30.387A1.984,1.984,0,0,0,37.74,24.282Z",
    transform: "translate(0 8.522) rotate(-13)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.63f3e2b379ef4d509cfafb8beec763ec.svg";
export { ForwardRef as ReactComponent };